import { render, staticRenderFns } from "./AddAd.vue?vue&type=template&id=b7b4ab5a&scoped=true&"
import script from "./AddAd.vue?vue&type=script&lang=js&"
export * from "./AddAd.vue?vue&type=script&lang=js&"
import style0 from "./AddAd.vue?vue&type=style&index=0&id=b7b4ab5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b4ab5a",
  null
  
)

export default component.exports